export interface MasterDBPaginatedRes<T> {
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	nextPage: string;
	prevPage: string;
	results: T;
}

export interface CartTeamRes {
	uuid: string;
	title: string;
	teamLeagueTitle: string;
	organizationUuid: string;
	teamLeagueUuid: string;
	teamUuid: string | null; // If null team is not yet created by the captain
	divisionUuid: string | null;
	createdByUuid: string;
	dateCreated: string;
	dateExpires: string;
	dateUpdated: string | null;
	captainUserUuid: string;
	captainPlayerUuid: string | null;
	captainFullName: string | null;
	players: Player[];
	additionalPlayersCount: number;
	teamPaysRegistration: boolean;
	seasonUuid: string;
}

export interface Player {
	uuid: string;
	cartTeamUuid: string;
	playerUuid: string;
	userUuid: string;
	teamPlayerStatus: 'TEAM_LEAGUE_TEAM_CAPTAIN' | 'TEAM_LEAGUE_TEAM_PLAYER' | string;
	mandatoryStatus: boolean;
	dateCreated: string;
	dateUpdated: string | null;
	paymentStatus: boolean;
	fullName: string | null;
	joinStatus: JoinStatus;
}

export enum JoinStatusEnum {
	JOIN_PLAYER_STATUS_UNDEFINED = 'JOIN_PLAYER_STATUS_UNDEFINED',
	JOIN_PLAYER_STATUS_TEAM_CREATION_JOIN = 'JOIN_PLAYER_STATUS_TEAM_CREATION_JOIN',
	JOIN_PLAYER_STATUS_FREE_AGENT_JOIN = 'JOIN_PLAYER_STATUS_FREE_AGENT_JOIN',
	JOIN_PLAYER_STATUS_INVITATION_CODE_JOIN = 'JOIN_PLAYER_STATUS_INVITATION_CODE_JOIN',
	JOIN_PLAYER_MANAGE_JOIN = 'JOIN_PLAYER_MANAGE_JOIN'
}

export type JoinStatus =
	| 'JOIN_PLAYER_STATUS_UNDEFINED'
	| 'JOIN_PLAYER_STATUS_TEAM_CREATION_JOIN'
	| 'JOIN_PLAYER_STATUS_FREE_AGENT_JOIN'
	| 'JOIN_PLAYER_STATUS_INVITATION_CODE_JOIN';

// accepted - the player settled their piece of the registration, so the invitation is closed
// pending - not accepted yet. Declining deletes the cart row, so it has no status of its own.
export type GetTeamRequestResStatus = 'accepted' | 'pending';

// Where the invited player stands on the team. The endpoint reports an open invite as INVITE_PENDING
// (never NOT_ON_TEAM); the two ON_TEAM values mean the player is already on the team.
export type TeamInvitePlayerStatus =
	| 'TEAM_LEAGUE_INVITE_PLAYER_STATUS_UNDEFINED'
	| 'TEAM_LEAGUE_INVITE_PLAYER_STATUS_NOT_ON_TEAM'
	| 'TEAM_LEAGUE_INVITE_PLAYER_STATUS_INVITE_PENDING'
	| 'TEAM_LEAGUE_INVITE_PLAYER_STATUS_ON_TEAM_NOT_IN_SEASON'
	| 'TEAM_LEAGUE_INVITE_PLAYER_STATUS_ON_TEAM_AND_IN_SEASON';

// A captain invite that raised no cart, as the invited player sees it.
export interface TeamInvitePlayerDetails {
	userUuid: string;
	playerUuid: string;
	playerFirstName?: string;
	playerLastName?: string;
	teamUuid: string;
	teamTitle?: string;
	teamCaptainFirstName?: string;
	teamCaptainLastName?: string;
	teamLeagueUuid: string;
	teamLeagueTitle?: string;
	activeSeasonUuid?: string;
	activeSeasonTitle?: string;
	playerStatus: TeamInvitePlayerStatus;
	pendingTransferRequestUuid?: string;
}

// interface UserInfo {
// 	uuid: string;
// 	email: string;
// 	phone: string;
// 	slug: string;
// 	firstName: string;
// 	lastName: string;
// 	age: number;
// 	gender: string;
// 	country: CountryInfo;
// 	state: StateInfo;
// 	city: string;
// }

// interface CountryInfo {
// 	abbreviation: string;
// 	id: string;
// 	internationalCountryCallingCode: string;
// 	title: string;
// 	stateTitle: string;
// 	zipCodeTitle: string;
// 	systemTextNumberId: string;
// 	abbreviation2Digit: string;
// 	displayOrder: string;
// 	isEnabled: boolean;
// 	regionType: string;
// }

// interface StateInfo {
// 	id: string;
// 	abbreviation: string;
// 	title: string;
// 	countryId: number;
// 	isEnabled: boolean;
// }
